module.exports = __webpack_public_path__ + "static/img/avatar-bar.539b7e40.png";